import { toggleHeader } from "../include/module";
import { anchorLink } from "../include/module";
import { newsPosition } from "../include/module";
import { showIndex } from "../include/module";
import { pageTopIndex } from "../include/module";
import { movieSlider } from "../include/module";
import { showMovie } from "../include/module";


(() => {

  toggleHeader();

  newsPosition();

  showIndex();

  pageTopIndex();

  movieSlider();

  showMovie();


})();



// WEBPACK FOOTER //
// ./src/assets/js/index/script.js